export default __webpack_public_path__ + "static/media/sm.20dd53e1.svg";